import Phaser from 'phaser';
import { GAME_CONFIG } from '../config';
import { Character } from '../objects/Character';

export class BlinkSystem {
  scene: Phaser.Scene;
  character: Character;

  constructor(scene: Phaser.Scene, character: Character) {
    this.scene = scene;
    this.character = character;
    this.scheduleNext();
  }

  private scheduleNext() {
    const min = GAME_CONFIG.BLINK_INTERVAL_MIN;
    const max = GAME_CONFIG.BLINK_INTERVAL_MAX;
    const delay = min + Math.random() * (max - min);
    this.scene.time.delayedCall(delay, () => this.tryBlink());
  }

  private tryBlink() {
    // Safety net: if a previous blink got stranded with the eyes closed
    // (e.g. a head swap raced with the BLINK_DURATION restore), recover here
    // before scheduling the next blink. Otherwise the original guard
    // `head === 'head_main'` would never fire again and the character would
    // stare with closed eyes forever.
    if (this.character.currentHeadKey === 'head_eyeclosed') {
      this.character.setHead('head_main');
    }

    if (this.character.currentHeadKey === 'head_main') {
      this.character.setHead('head_eyeclosed');
      this.scene.time.delayedCall(GAME_CONFIG.BLINK_DURATION, () => {
        if (this.character.currentHeadKey === 'head_eyeclosed') {
          this.character.setHead('head_main');
        }
      });
    }
    this.scheduleNext();
  }
}
